module.exports = __webpack_public_path__ + "static/sc-01.f380de0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/vtbb/sc-01.png
// module id = 96
// module chunks = 88197199937824 213720915766396 230169651102138